import {FilingSignature, officerName, renewalConsent, signatureIsValid, signatureMatchesName} from './renewal-signature';
import consent from '../../../backend/resources/reinstatement-consent.json';
import {registeredAgentName} from './company-review';

export const reinstatementConsent = {...renewalConsent, ...consent.officer};
export const reinstatementAgentConsent = {...renewalConsent, ...consent.registeredAgent};

export type ReinstatementSignature = FilingSignature;

export interface RegisteredAgentApproval {
    signature: ReinstatementSignature;
    reviewedCompany: any;
}

export interface ReinstatementSignatures {
    registeredAgent: ReinstatementSignature;
    officer: ReinstatementSignature & {signerIndex: number; id: string | number | null};
}

export function reinstatementSignature(agent: any, principalName: string, value: string, typed: boolean): ReinstatementSignature {
    if (!['P', 'C'].includes(agent?.type)) throw new Error('Update the registered agent and select Individual or Business entity before signing.');
    const name = agent.type === 'C' ? principalName.trim() : registeredAgentName(agent);
    if (agent.type === 'C' && name.toLowerCase() === registeredAgentName(agent).toLowerCase()) {
        throw new Error('A principal of the registered-agent business must sign in their own name.');
    }
    if (!signatureMatchesName(name, value, typed)) throw new Error('Please provide a valid signature for the registered agent.');
    return {name, signatureValue: value.trim(), signatureType: typed ? 'typed' : 'drawn', accepted: true, consent: reinstatementAgentConsent};
}

export function approveRegisteredAgent(reviewedCompany: any, principalName: string, value: string, typed: boolean): RegisteredAgentApproval {
    return {signature: reinstatementSignature(reviewedCompany.registeredAgent, principalName, value, typed),
        reviewedCompany: JSON.parse(JSON.stringify(reviewedCompany))};
}

export function completeReinstatementSignatures(approval: RegisteredAgentApproval | null, reviewedCompany: any,
    signerIndex: number, value: string, typed: boolean): ReinstatementSignatures {
    if (!approval || JSON.stringify(approval.reviewedCompany) !== JSON.stringify(reviewedCompany)) {
        throw new Error('Company details changed. The registered agent must review and sign again.');
    }
    const officer = Number.isInteger(signerIndex) ? reviewedCompany.officers[signerIndex] : null;
    if (!signatureIsValid(officer, value, typed)) throw new Error('Select an officer and provide their signature.');
    return {registeredAgent: approval.signature, officer: {
        name: officerName(officer), id: officer.id ?? null, signerIndex,
        signatureValue: value.trim(), signatureType: typed ? 'typed' : 'drawn', accepted: true, consent: reinstatementConsent,
    }};
}
